import { render, staticRenderFns } from "./notified-referrers.vue?vue&type=template&id=45b47530"
import script from "./notified-referrers.vue?vue&type=script&lang=js"
export * from "./notified-referrers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports